// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriptionSection_container__RDjNm","buttonContainer":"SubscriptionSection_buttonContainer__3S7d7","paragraph":"SubscriptionSection_paragraph__2TCZG"};